export const formatDeviceId = (id: string = "") => id.slice(-6);

angular
    .module("thor.core.auth.formatDeviceId.filter", [])
    .filter("formatDeviceId", () => formatDeviceId);
